import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SubscriptionPlansService } from 'src/app/modules/home/services/subscription-plans.service';

@Component({
  selector: 'app-upgrade-plan-modal',
  templateUrl: './upgrade-plan-modal.component.html',
  styleUrls: ['./upgrade-plan-modal.component.scss']
})
export class UpgradePlanModalComponent {
  planForm!: FormGroup;
  subscriptionPlans: any[] = [];
  selectedPlan: any = null;
  loginDetails: any = {}; // Assume admin login
  currentPlan: any = null;
  filteredPlans: any[] = [];
  currentSubscription: any;

  constructor(
    public dialogRef: MatDialogRef<UpgradePlanModalComponent>,
 
    @Inject(MAT_DIALOG_DATA) public userSubscriptions: any,
    private fb: FormBuilder,
    private subscriptionPlansService: SubscriptionPlansService,
  ) {
    this.planForm = this.fb.group({
      selectedPlan: ['', Validators.required],
      billingType: ['', Validators.required]
    });
  }
ngOnInit(){
     this.loadPlans();
       console.log(this.userSubscriptions); 
}


loadPlans(): void {
  this.subscriptionPlansService.getSubscriptionPlans().subscribe((plans: any[]) => {
    this.subscriptionPlans = plans;

    // Get current plan from injected userSubscriptions
    const currentSubscription = this.userSubscriptions[0]?this.userSubscriptions[0]:this.userSubscriptions;
    const currentPlan = currentSubscription.subscription_plan?currentSubscription.subscription_plan:currentSubscription;
    this.currentSubscription = currentSubscription;
    if (currentPlan.length > 0) {
      this.currentPlan = currentPlan;

      // Filter available plans of the same type
      this.filteredPlans = this.subscriptionPlans.filter(
        plan => plan.type === currentPlan.type
      );
      console.log(this.filteredPlans)
    } else {
      this.filteredPlans = this.subscriptionPlans
    }

    // Initialize form fields
    this.planForm.patchValue({
      selectedPlan: null,
      billingType: null
    });
  });
}


  onPlanChange(plan: any) {
    this.selectedPlan = plan;
  }
  onSubmit(): void {
    if (this.planForm.valid) {
      const formValues = this.planForm.value;
      console.log('Form Submitted', formValues);
      this.dialogRef.close(formValues); // or handle the upgrade logic
    }
  }
}
